import {createUrl} from "../utils/Actions";
import {baseUrl} from "../constants/Base";

const axios = require('axios');

const api = (method : string, action : string, data : object, headers : object,
             func : string = null, url : string = baseUrl) => {
    const config = {
        url: createUrl(method, action),
        method: method,
        baseURL: url,
        data: data,
        headers: headers
    }

    return axios
        .request(config)
        .then((response: { data: any; }) => response.data);
};

export default api;